// typings

import { create } from "zustand";
import { persist } from "zustand/middleware";

import { IHistoricoRemessaState } from "@/store-zustand/cliente/historico-de-remessa-do-cliente/index.d";

// criação da store com Zustand (Histórico de Remessas)
export const useStoreZustandHistoricoRemessa = create<IHistoricoRemessaState>()(
  persist(
    (set) => ({
      // estados
      isLoading: false,
      isModalSolicitacaoRemessa: false,
      paginations: [1],
      itemsPerPage: 5,
      currentPage: 1,
      totalItemsPage: 0,
      searchItem: "",
      lastPage: 0,
      remessaHistoricoUnica: null,

      // ações
      setIsLoading: (isLoading) => set({ isLoading }),
      setItemsPerPage: (itemsPerPage) => set({ itemsPerPage }),
      setCurrentPage: (currentPage) => set({ currentPage }),
      setTotalItemsPage: (totalItemsPage) => set({ totalItemsPage }),
      setSearchItem: (searchItem) => set({ searchItem }),
      setLastPage: (lastPage) => set({ lastPage }),
      setPaginations: (paginations) => set({ paginations }),

      setRemessaHistoricoUnica: (remessaHistoricoUnica) => set({ remessaHistoricoUnica }),

      clearPersistedData: () =>
        set({
          remessaHistoricoUnica: null, // limpar apenas o remessaEmAndamentoUnico
        }),
    }),
    {
      name: "store-remessa-historico", // nome da chave no localStorage
      partialize: (state) => ({
        remessaHistoricoUnica: state.remessaHistoricoUnica, // persistir apenas o remessaEmAndamentoUnico
      }),
    }
  )
);
